import { InjectionToken } from "@angular/core";

export const SP_IMAGE_URL = new InjectionToken<string>('SP_IMAGE_URL');